export const joinSchoolModalStyles = {
  select: {
    width: '200px',
    margin: '0 auto',
    marginBottom: '28px'
  },
  button: {
    width: '200px',
    display: 'flex',
    margin: '0 auto',
    justifyContent: 'center'
  },
  desc: {
    maxWidth: '300px',
    margin: '0 auto 28px !important'
  }
}

const styles = ({ COLORS }) => ({
  success: {
    fontWeight: 'bold',
    color: COLORS.GREEN.NORMAL,
    padding: '0 10px'
  },
  cancelBtn: {
    margin: '0 10px'
  },
  requestSchoolAccessButton: {
    marginBottom: 'auto'
  }
})

export default styles
